import { HttpBaseApiWrapper } from 'service/HttpBaseApiWrapper'

import { IRequiredAction } from '../domain/ShipmentInterface'

export class RequiredActionsService {
  http: HttpBaseApiWrapper
  constructor(http: HttpBaseApiWrapper) {
    this.http = http
  }
  getMany(ids: string[]): Promise<Record<string, IRequiredAction[]>> {
    return this.http.get(`/required-actions/shipments?shipmentIds=${ids.join(',')}`)
  }
}
